import React, { useState } from 'react';
import { FormControl, Select, InputBase, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DownArrowSVG } from '../svg/DownArrowSVG';

const LANGUAGES = {
    en: { title: 'EN' },
    es: { title: 'ES' }
};

const LanguageSelector = ({ className, fill }) => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    return (
        <FormControl sx={{ marginRight: '5px', ...(className || {}) }}>
            <Select
                input={<InputBase className='inputBase' />}
                value={i18n.resolvedLanguage}
                onChange={(e) => i18n.changeLanguage(e.target.value)}
                className='selectCustom'
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                IconComponent={(props) => (
                    <span
                        {...props}
                        style={{
                            position: 'absolute',
                            top: '40%',
                            transform: isOpen
                                ? 'translateY(-50%) rotate(180deg)'
                                : 'translateY(-50%) rotate(0deg)',
                            transition: 'transform 0.2s ease'
                        }}
                    >
                        <DownArrowSVG fill={fill} />
                    </span>
                )}
                sx={{
                    '& .MuiSelect-select': {
                        paddingRight: '28px !important',
                        color: fill || 'inherit'
                    }
                }}
            >
                {Object.keys(LANGUAGES).map(lang => {
                    const isSelect = i18n.resolvedLanguage === lang;
                    return (
                        <MenuItem
                            key={lang}
                            value={lang}
                            className={`custom-options${isSelect ? '-selected' : ''}`}
                            sx={{
                                color: isSelect ? (fill || 'inherit') : 'inherit'
                            }}
                        >
                            {lang.toUpperCase()}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};

export default LanguageSelector;
